import BaseFilter, {
  type BaseFilterType,
} from "@search/store/filters/base/BaseFilter";

class StringFilter extends BaseFilter {
  constructor({
    defaultValue,
    name = "string",
    label = name,
    value,
  }: BaseFilterType) {
    super({ defaultValue, label, name, value: value as string });
  }

  get defaultValue() {
    return super.defaultValue as string;
  }

  get initialValue() {
    return super.initialValue as string;
  }

  get value() {
    return super.value as string;
  }
}

export default StringFilter;
export { StringFilter };
